import { UserRoleResponse } from '../../../api/dtos/user/UserRoleResponse';
import { CLEAR_CACHE } from '../types';
import { API_USER_NAME_UPDATED, API_USER_PASSWORD_UPDATED, API_USER_PROFILE_LOADED, API_USER_REGISTER, API_USER_REMOVED, API_USER_ROLE_UPDATED, API_USERS_LOADED, ApiUserProfileActionTypes, UserProfileState } from './types';

const InitialState: UserProfileState = {
	user: {
		id: 0,
		name: '',
		email: '',
		role: UserRoleResponse.Employee,
	},
	users: [],
	isLoaded: false,
};

export default function UserProfileReducer(state: UserProfileState = InitialState, action: ApiUserProfileActionTypes): UserProfileState {
	switch (action.type) {
		case API_USER_PROFILE_LOADED:
			return {
				...state,
				user: action.user,
				isLoaded: true
			}
		case API_USER_NAME_UPDATED:
			return {
				...state,
				user: {
					...state.user,
					name: action.name,
				},
			}
		case API_USER_PASSWORD_UPDATED:
			return {
				...state,
			}
		case API_USER_REGISTER:
			return {
				...state,
				users: [...state.users, { email: action.email, role: action.role }],
			};
		case API_USERS_LOADED:
			return {
				...state,
				users: action.users,
			};
		case API_USER_ROLE_UPDATED:
			return {
				...state,
				users: state.users.map(user =>
					user.id === action.userId
						? { ...user, data: { ...user, role: action.role } }
						: user
				)
			};
		case API_USER_REMOVED:
			return {
				...state,
				users: state.users.filter(user => user.id !== action.userId),
			};
		case CLEAR_CACHE:
			return InitialState;
		default:
			return state;
	}
}
